"use client";

import { pushConsentStatusToDataLayer, pushToDataLayer } from "@/common/utils/GtmUtils";
import { useEffect } from "react";
import * as CookieConsent from "vanilla-cookieconsent";
import "vanilla-cookieconsent/dist/cookieconsent.css";

const CookieConsentBanner = () => {
    useEffect(() => {
        pushConsentStatusToDataLayer();

        CookieConsent.run({
            disablePageInteraction: true,
            guiOptions: {
                consentModal: {
                    layout: "box",
                    position: "bottom right",
                    equalWeightButtons: true,
                    flipButtons: false,
                },
                preferencesModal: {
                    layout: "box",
                    position: "right",
                    equalWeightButtons: true,
                    flipButtons: false,
                },
            },
            categories: {
                necessary: {
                    enabled: true,
                    readOnly: true,
                },
                analytics: {},
                marketing: {},
            },
            language: {
                default: "ro",
                translations: {
                    ro: {
                        consentModal: {
                            title: "Folosim cookies",
                            description:
                                "Folosim cookies pentru a personaliza conținutul și anunțurile, pentru a oferi funcții de rețele sociale și pentru a analiza traficul. Poți accepta sau personaliza preferințele.",
                            acceptAllBtn: "Accept toate",
                            acceptNecessaryBtn: "Doar necesare",
                            showPreferencesBtn: "Setează preferințele",
                        },
                        preferencesModal: {
                            title: "Preferințe cookies",
                            acceptAllBtn: "Accept toate",
                            acceptNecessaryBtn: "Doar necesare",
                            savePreferencesBtn: "Salvează preferințele",
                            closeIconLabel: "Închide",
                            sections: [
                                {
                                    title: "Cookies necesare",
                                    description: "Aceste cookies sunt necesare pentru funcționarea site-ului și nu pot fi dezactivate.",
                                },
                                {
                                    title: "Cookies analitice",
                                    description: "Ne ajută să înțelegem cum este utilizat site-ul nostru.",
                                    linkedCategory: "analytics",
                                },
                                {
                                    title: "Cookies marketing",
                                    description: "Folosite pentru reclame și tracking personalizat.",
                                    linkedCategory: "marketing",
                                },
                            ],
                        },
                    },
                },
            },
            onConsent: (consent: any) => {
                const granted = (key: string) => (consent.acceptedCategories?.includes(key) ? "granted" : "denied");

                if (consent.acceptedCategories?.includes("analytics")) {
                    document.cookie = "cookie_consent=analytics; path=/; max-age=31536000";
                }
                if (consent.acceptedCategories?.includes("marketing")) {
                    document.cookie = "cookie_consent=marketing; path=/; max-age=31536000";
                }

                pushToDataLayer("cookie_consent_update", {
                    consent: {
                        ad_storage: granted("marketing"),
                        analytics_storage: granted("analytics"),
                        ad_user_data: granted("marketing"),
                        ad_personalization: granted("marketing"),
                        functionality_storage: "granted",
                        personalization_storage: granted("marketing"),
                        security_storage: "granted",
                    },
                });
            },
        });
    }, []);

    return null;
};

export default CookieConsentBanner;
